const AccountLogout = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22.439 19.634">
      <path
        data-name="Icon open-account-logout"
        d="M8.414 0v2.8h11.22v14.029H8.414v2.8h14.025V0zM5.61 5.61 0 9.817l5.61 4.207v-2.8h11.219v-2.8H5.61z"
      />
    </svg>
  );
};

export default AccountLogout;
